import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bfd1a4c6")

_pushScopeId("data-v-bfd1a4c6")
const _hoisted_1 = { class: "detail-image-view" }
const _hoisted_2 = { class: "detail-image-view-image" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.imageUrl)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "detail-image-view-image-icon",
            src: _ctx.imageUrl,
            style: _ctx.styleImage
          }, null, 12, ["src"]))
        : _createCommentVNode("", true)
    ])
  ]))
})